'use strict';

(function ($, Drupal, once) {
  Drupal.behaviors.execEdNav = {
    attach: function (context) {
      $(once('execEdNav', '.ee-nav', context)).each(function () {
        var $nav = $(this);
        var timerId;

        // We don't want the main nav to be sticky when we have the exec-ed nav.
        $('body').addClass('skip-main-sticky-nav');

        $(window).scroll(function () {
          if (!timerId) {
            timerId = setTimeout(function() {
              var scroll = window.pageYOffset || document.documentElement.scrollTop;
              var anchorPos = $('#ee-nav-anchor').offset();
              var topOffset = 0;

              if (anchorPos) {
                // This handles the case where the admin toolbar is present.
                topOffset = $('body').css('padding-top').replace("px", "");
              }

              // If we've scrolled past the anchor (with top offset adjustment), switch to affixed mode.
              if (anchorPos && (scroll >= (anchorPos.top-topOffset))) {
                $nav.addClass('affix');
                $nav.css('top', topOffset+'px');
              }
              else {
                $nav.removeClass('affix');
                $nav.css('top', '');
              }

              timerId = null;
            }, 200);
          }
        });
      });
    }
  };
})(jQuery, Drupal, once);
